
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdatePermissionDtoFormGroup() {
return new FormGroup({
    name: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(100)]),
})
;
}
      